<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconAppWechat',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg
      width="17px"
      height="16px"
      viewBox="0 0 17 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>编组 12</title>
      <g id="抓潜拓客" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="企业详情-联系方式-解锁" transform="translate(-274.000000, -986.000000)">
          <g id="编组-20" transform="translate(242.000000, 565.000000)">
            <g id="编组-5" transform="translate(0.000000, 400.000000)">
              <g id="编组-12" transform="translate(32.000000, 21.000000)">
                <g id="编组-14" transform="translate(1.000000, 2.000000)">
                  <path
                    id="路径"
                    d="M10,3.75 L9.73381454,3.04750895 C9.06254682,1.27494799 7.19670678,0 5,0 C2.23857625,0 0,2.01471863 0,4.5 C0,5.74264069 0.559644063,6.86764069 1.46446609,7.68198052 C1.88960377,8.06460443 2.39094513,8.37864503 2.94624385,8.60408064 C3.2644115,8.73324773 2.14141157,10.1730081 2.49082211,10.2402327 C2.82948156,10.3053888 4.63973172,9 5,9 C5.72971094,9 6.42291199,8.85931428 7.04794378,8.60643626"
                    stroke="#242934"
                  ></path>
                  <circle id="椭圆形" fill="#242934" cx="2.75" cy="3.75" r="1"></circle>
                  <circle id="椭圆形" fill="#242934" cx="6.75" cy="3.75" r="1"></circle>
                </g>
                <g
                  id="编组-14"
                  transform="translate(12.000000, 10.000000) scale(-1, 1) translate(-12.000000, -10.000000) translate(8.000000, 6.000000)"
                >
                  <path
                    id="椭圆形"
                    d="M4,7.02946992 C6.209139,7.02946992 8,5.45586948 8,3.51473496 C8,1.57360044 6.209139,0 4,0 C1.790861,0 0,1.57360044 0,3.51473496 C0,4.48530222 0.44771525,5.36398596 1.17157288,6.00002788 C1.51168302,6.29887713 1.9127561,6.54415924 2.35699508,6.72023623 C2.6115292,6.82112247 1.71312926,7.94565046 1.99265769,7.9981564 C2.26358525,8.04904676 3.71178538,7.02946992 4,7.02946992 Z"
                    stroke="#242934"
                  ></path>
                  <circle id="椭圆形" fill="#242934" cx="2.65" cy="2.65" r="1"></circle>
                  <circle id="椭圆形" fill="#242934" cx="5.65" cy="2.65" r="1"></circle>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </i>
</template>
